import { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";

type Props = {
  open: boolean;
  fileName: string | null;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
};

export const DeleteConfirmDialog: FC<Props> = ({
  open,
  fileName,
  onCancel,
  onConfirm,
  isSubmitting
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>Delete file?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        <strong>{fileName}</strong> will be permanently removed. This cannot be
        undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={isSubmitting}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Deleting..." : "Delete"}
      </Button>
    </DialogActions>
  </Dialog>
);
